import { Link, type LinkProps } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

type AppLinkProps = Omit<LinkProps, "href"> & {
  href: string;
  external?: boolean;
};

export const AppLink = ({ href, external = false, ...rest }: AppLinkProps) => {
  if (!external && href.startsWith("/")) {
    return <Link as={RouterLink} to={href} {...rest} />;
  }

  return <Link href={href} isExternal={external} rel={external ? "noopener" : undefined} {...rest} />;
};
